import React, { useState } from "react";
import { X } from "lucide-react";
import Reveal from "./Reveal";
import { LOOKBOOK } from "../data/data";

export function Lookbook() {
  const [active, setActive] = useState(null);

  return (
    <section className="py-24 px-6 md:px-10" style={{ background: "#12161F" }}>
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="uppercase tracking-widest text-xs mb-3" style={{ fontFamily: "'JetBrains Mono', monospace", color: "#1E9AFF" }}>
            The Lookbook
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 style={{ fontFamily: "Fraunces, serif" }} className="text-4xl md:text-5xl mb-14">
            Get the look
          </h2>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {LOOKBOOK.map((l, i) => (
            <Reveal key={l.title} delay={i * 0.07}>
              <button
                onClick={() => setActive(l)}
                className="group relative w-full h-80 rounded-2xl overflow-hidden text-left transition-transform duration-200 active:scale-95"
              >
                <img
                  src={l.image}
                  alt={l.title}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full transition-transform duration-500 group-hover:scale-110"
                  style={{ objectFit: "cover" }}
                />
                <div
                  className="absolute inset-0"
                  style={{ background: "linear-gradient(180deg, rgba(16,20,27,0) 40%, rgba(16,20,27,0.75) 100%)" }}
                ></div>
                <span
                  className="absolute bottom-5 left-5 text-white text-lg"
                  style={{ fontFamily: "Fraunces, serif" }}
                >
                  {l.title}
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      {active && (
        <div
          className="lightbox-overlay fixed inset-0 z-50 flex items-center justify-center p-6"
          style={{ background: "rgba(11,14,19,0.9)" }}
          onClick={() => setActive(null)}
        >
          <div className="lightbox-content relative max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={active.image}
              alt={active.title}
              className="w-full max-h-[80vh] rounded-2xl"
              style={{ objectFit: "cover" }}
            />
            <p className="text-white text-center mt-4 text-lg" style={{ fontFamily: "Fraunces, serif" }}>
              {active.title}
            </p>
            <button
              onClick={() => setActive(null)}
              className="absolute -top-4 -right-4 w-10 h-10 rounded-full flex items-center justify-center transition-transform hover:scale-110 active:scale-90"
              style={{ background: "#1E9AFF" }}
              aria-label="Close"
            >
              <X size={18} color="#fff" />
            </button>
          </div>
        </div>
      )}
    </section>
  );
}

export default Lookbook;
